'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIStatusTag from 'UIComponents/tag/UIStatusTag';
import { EntityStatusToStatusTagMap, Networks } from '../../lib/Constants';
import { adStatus, adGroupStatus, campaignStatus } from '../../lib/entityStatus';

const EntityStatusTag = ({
  derivedStatus,
  hollow,
  use,
  color
}) => /*#__PURE__*/_jsx(UIStatusTag, Object.assign({
  hollow: hollow
}, use && {
  use
} || {}, {}, color && {
  color
} || {}, {
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `campaigns.campaignTable.status.${derivedStatus}`
  })
}));

export const CampaignStatusTag = ({
  campaignEntity
}) => {
  const derivedStatus = campaignStatus(campaignEntity);
  const {
    use,
    hollow,
    color
  } = EntityStatusToStatusTagMap[derivedStatus];
  return /*#__PURE__*/_jsx(EntityStatusTag, {
    derivedStatus: derivedStatus,
    use: use,
    hollow: hollow,
    color: color
  });
};
const campaignEntityPropType = PropTypes.shape({
  effectiveStatus: PropTypes.string,
  endTime: PropTypes.number,
  network: PropTypes.oneOf(Object.keys(Networks)).isRequired,
  startTime: PropTypes.number,
  status: PropTypes.string.isRequired
});
CampaignStatusTag.propTypes = {
  campaignEntity: campaignEntityPropType.isRequired
};
export const AdGroupStatusTag = ({
  adGroupEntity,
  campaignEntity
}) => {
  const derivedStatus = adGroupStatus(adGroupEntity, campaignEntity);
  const {
    use,
    hollow,
    color
  } = EntityStatusToStatusTagMap[derivedStatus];
  return /*#__PURE__*/_jsx(EntityStatusTag, {
    derivedStatus: derivedStatus,
    use: use,
    hollow: hollow,
    color: color
  });
};
const adGroupEntityPropType = PropTypes.shape({
  effectiveStatus: PropTypes.string,
  status: PropTypes.string
});
AdGroupStatusTag.propTypes = {
  adGroupEntity: adGroupEntityPropType.isRequired,
  campaignEntity: campaignEntityPropType.isRequired
};
export const AdStatusTag = ({
  adEntity,
  adGroupEntity,
  campaignEntity
}) => {
  const derivedStatus = adStatus(adEntity, adGroupEntity, campaignEntity);
  const {
    use,
    hollow,
    color
  } = EntityStatusToStatusTagMap[derivedStatus];
  return /*#__PURE__*/_jsx(EntityStatusTag, {
    derivedStatus: derivedStatus,
    use: use,
    hollow: hollow,
    color: color
  });
};
const adEntityPropType = PropTypes.shape({
  effectiveStatus: PropTypes.string,
  status: PropTypes.string
});
AdStatusTag.propTypes = {
  adEntity: adEntityPropType.isRequired,
  adGroupEntity: adGroupEntityPropType.isRequired,
  campaignEntity: campaignEntityPropType.isRequired
};